import React from 'react';
import { Card, Tabs } from 'antd';
import { useLocation } from 'react-router-dom';

import Main from '../../components/layout/Main';

import SchoolIndicatorsData from '../../components/SchoolIndicatorsData';
import CompetitionsListing from '../../components/Competitions/CompetitionsListing';
import AllIndicatorStatistics from '../../components/AllIndicatorStatistics';
import ScLibrary from '../../components/ScLibrary';
import ScInternet from '../../components/ScInternet';
import ScSeminars from '../../components/ScSeminars';
import ScGoodPractices from '../../components/ScGoodPractices';
import ScConsultation from '../../components/ScConsultation';
import ScProjectsPartnership from '../../components/ScProjectsPartnership';
import EducationCenterBvmSurveys from '../../components/EducationCenterBvmSurveys';
import SchoolIndicatorsCalendar from '../../components/SchoolIndicatorsCalendar';
import ScExpertise from '../../components/ScExpertise';
import ScLeadershipManagement from '../../components/ScLeadershipManagement';
import ScPlanningAdministration from '../../components/ScPlanningAdministration';
import ScProgramsEvaluation from '../../components/ScProgramsEvaluation';

import './educationCenterIndicators.scss';

const { TabPane } = Tabs;

const EducationCenterIndicators = () => {
    const location = useLocation();
    const defaultActiveKey = location.state?.activeTab || '1';
    const toolbar = [{ label: 'Item 1', link: '/abc', iconName: 'home' }];

    return (
        <Main
            className="login"
            title={<div>Švietimo centro rodikliai</div>}
            headerTitle={<div>Švietimo centro rodikliai</div>}
            menuWidth={350}
            menuPlacement="left"
            toolbar={toolbar}
            showFooter={false}
            floatingHeader={false}
            footerContent={<div style={{ lineHeight: '30px', fontSize: '16px', float: 'right' }}>&copy; copyright 2020</div>}
            floatingFooter
            backLink={false}
            breadcrumb={null}>
            <Card>
                <Tabs
                    defaultActiveKey={defaultActiveKey}
                    items={[
                        {
                            key: '1',
                            label: 'Rodikliai',
                            children: <SchoolIndicatorsData scope="education_center" />,
                        },
                        {
                            key: '2',
                            label: 'Konkursai',
                            children: <CompetitionsListing />,
                        },
                        {
                            key: '4',
                            label: '(ŠC) Šiaulių kompetencijų Centro akreditacija',
                            children: (
                                <Tabs defaultActiveKey="1">
                                    <TabPane tab="Biblioteka" key="s1">
                                        <ScLibrary />
                                    </TabPane>
                                    <TabPane tab="Internetas" key="s2">
                                        <ScInternet />
                                    </TabPane>
                                    <TabPane tab="Seminarai, kursai, paskaitos ir kiti renginiai" key="s3">
                                        <ScSeminars />
                                    </TabPane>
                                    <TabPane tab="Gerosios patirties sklaida ir edukacinės patirties bankas" key="s4">
                                        <ScGoodPractices />
                                    </TabPane>
                                    <TabPane tab="Konsultavimas" key="s5">
                                        <ScConsultation />
                                    </TabPane>
                                    <TabPane tab="Projektinė veikla ir partnerystės tinklai" key="s6">
                                        <ScProjectsPartnership />
                                    </TabPane>
                                    <TabPane tab="Ekspertizė (Direktorė)" key="s7">
                                        <ScExpertise />
                                    </TabPane>
                                    <TabPane tab="Vadovavimas, personalo vadyba ir įvaizdžio kūrimas. DIREKTORĖ" key="s8">
                                        <ScLeadershipManagement />
                                    </TabPane>
                                    <TabPane tab="Planavimas ir administravimas DIREKTORĖ" key="s9">
                                        <ScPlanningAdministration />
                                    </TabPane>
                                    <TabPane tab="Kvalifikacijos tobulinimo programų vadyba DIREKTORĖ" key="s10">
                                        <ScProgramsEvaluation />
                                    </TabPane>
                                </Tabs>),
                        },
                        {
                            key: '5',
                            label: 'Rodiklių statistika',
                            children: <AllIndicatorStatistics />,
                        },
                        {
                            key: '6',
                            label: 'BVM Apklausos',
                            children: <EducationCenterBvmSurveys />,
                        },
                        {
                            key: '7',
                            label: 'Rodiklių kalendorius',
                            children: <SchoolIndicatorsCalendar department="education_center" />,
                        },
                    ]} />
            </Card>
        </Main>
    );
};

export default EducationCenterIndicators;

EducationCenterIndicators.propTypes = {};
